import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { SiteMapUrl } from 'src/app/core/_enums/sitemap.url';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { UserEntity } from 'src/app/core/_models/userEntity';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { UserEntityService } from 'src/app/core/_services/user.entity.service';
import { UpdateResourceAction } from 'src/app/store/actions/resource.actions';
import { AppState } from 'src/app/store/app.state';
import { DialogOverviewComponent } from '../shared/dialog-overview/dialog-overview.component';

@Component({
  selector: 'app-user-entity',
  templateUrl: './user-entity.component.html',
  styleUrls: ['./user-entity.component.scss']
})
export class UserEntityComponent implements OnInit {
  form!: FormGroup;

  constructor(
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userEntityService: UserEntityService,
    private dialog: MatDialog,
    private router: Router,
    private snackbarService: SnackbarService,
    private store: Store<AppState>,
    private translate: TranslateService
  ) {
    this.form = this.formBuilder?.group({
      euId: [],
      memberId: [],
      code: [null, Validators.required],
      displayName: [null, Validators.required],
      parent: [{ value: null, disabled: true }]
    });
  }

  get formCrls() {
    return this.form?.controls;
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      if (history.state.euId) {
        this.userEntityService.getEu(history.state.euId).subscribe(async (eu) => {
          this.form.patchValue(eu);
        });
      } else {
        this.form.patchValue({ memberId: history.state.memberId });
      }
    });
  }

  clickDelete(euId: string) {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_delete_user_entity') }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.delete(euId);
      }
    });
  }

  delete(euId: string) {
    if (euId) {
      this.userEntityService.deleteEu(euId).subscribe({
        next: (data) => {
          this.majStore(SnackbarTypes.delete);
          this.router.navigate([SiteMapUrl.MenuUserEntity]);
        },
        error: (error) => {
          this.snackbarService.open(SnackbarTypes.error);
          console.error(error);
        }
      });
    }
  }

  majStore(snackbarMsgType: string) {
    this.userEntityService.getAll(this.formCrls?.memberId?.value).subscribe(
      (arr) => {
        if (arr) {
          this.store.dispatch(new UpdateResourceAction(arr));
          this.snackbarService.open(snackbarMsgType);
        }
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    );
  }

  async clickSave(eu: UserEntity) {
    if (this.form.invalid) {
      return;
    }

    const isUpdate = !!this.formCrls?.euId?.value;
    let rep = await this.onUpdateOrSaveAch(eu);
    rep.subscribe({
      next: (data: UserEntity) => {
        this.majStore(isUpdate ? SnackbarTypes.update : SnackbarTypes.add);
        this.form.patchValue(data);
        this.router.navigate([SiteMapUrl.MenuUserEntity, data?.euId]);
      },
      error: () => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    });
  }

  onUpdateOrSaveAch(eu: UserEntity) {
    return this.formCrls?.euId?.value ? Promise.resolve(this.userEntityService.updateEu(eu)) : Promise.resolve(this.userEntityService.addEu(eu));
  }
}
